import { Auth } from "@/features";
import { Logo } from "@/shared/ui";

export const AuthForm = () => {
  Logo("2xl");
  Auth();
};
